import { useEffect, useRef } from "react";

export const Loader = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const cx = 35, cy = 35;
    const dark = "#1d5242";
    const light = "#5DCAA5";
    const colors = [light, dark, light, dark];
    const baseAngles = [-Math.PI*3/4, -Math.PI/4, Math.PI/4, Math.PI*3/4];
    let t = 0;
    let raf;

    function loop() {
      ctx.clearRect(0, 0, 70, 70);
      t += 0.064;

      const breathe = (Math.sin(t * 0.9) + 1) / 2;
      const circleR = 7;                  // fixed — no size transition
      const orbitR  = 11 + breathe * 9;  // only orbit pulses

      for (let i = 0; i < 4; i++) {
        const angle = baseAngles[i] + t;
        const px = Math.cos(angle) * orbitR;
        const py = Math.sin(angle) * orbitR;

        ctx.beginPath();
        ctx.arc(cx + px, cy + py, circleR, 0, Math.PI * 2);
        ctx.fillStyle = colors[i];
        ctx.fill();
      }

      raf = requestAnimationFrame(loop);
    }

    loop();
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <canvas ref={canvasRef} width={70} height={70} />
    </div>
  );
};